import React from 'react';
import { toSentence } from 'utilities/formatting';
import { CheckpointCardProps } from '@magoosh/gre/organisms/checkpoint_card/types';
import { Checkpoint } from './types';
import CheckpointCard from '@magoosh/gre/organisms/checkpoint_card';
import ContextualLink from '@magoosh/gre/app/contextual_link';
import CelebrationAstronautIllustration from './assets/celebration_astronaut.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  checkpoint: Checkpoint;
  dismissRefresh: () => void;
  refreshPlan: () => void;
  subsectionsToPrioritizeOnRefresh: string[];
}

const PrioritizedRefreshCheckpoint: React.FC<Props> = ({ checkpoint, dismissRefresh, refreshPlan, subsectionsToPrioritizeOnRefresh }) => {
  const primaryCTA = {
    text: 'Refresh My Study Plan',
    variant: 'secondary',
    onClick: refreshPlan,
    target: '_blank'
  };

  const secondaryCTA = (
    <ContextualLink
      className="u-margin-H-xs"
      style={{ color: colors.grayDarker }}
      onClick={dismissRefresh}
    >
      Dismiss
    </ContextualLink>
  );

  const children = (
    <p>
      Based on your latest practice we recommend a shift in your study plan to focus more on <span dangerouslySetInnerHTML={{__html: toSentence(subsectionsToPrioritizeOnRefresh, (item) => `<u>${item}</u>`)}} />.
    </p>
  );

  const checkpointProps: CheckpointCardProps = {
    children,
    headline: 'Your Study Plan Just Got Better!',
    iconType: 'Complete',
    illustration: <img src={CelebrationAstronautIllustration} alt="Astronaut celebrating in space" />,
    isWrapped: true,
    primaryCTA,
    secondaryCTA
  };

  return (
    <CheckpointCard {...checkpointProps} />
  );
};

export default PrioritizedRefreshCheckpoint;
